__webpack_require__.p = "/WebChat-release-testing/01.create-react-app/";